import { Sun, Cloud, CloudRain, Zap, CloudSnow } from 'lucide-react';

export type WeatherCondition = 'sun' | 'partly' | 'cloud' | 'rain' | 'storm';

export const weatherOptions = [
  { value: 'sun', label: 'Ensolarado', icon: Sun },
  { value: 'partly', label: 'Parcialmente nublado', icon: CloudSnow },
  { value: 'cloud', label: 'Nublado', icon: Cloud },
  { value: 'rain', label: 'Chuva', icon: CloudRain },
  { value: 'storm', label: 'Tempestade', icon: Zap },
] as const;

export const getWeatherIconPlaceholder = (condition: string) => {
  const option = weatherOptions.find(opt => opt.value === condition);
  return option ? option.icon : Sun;
};

export const getWeatherIconColor = (condition: string) => {
  switch (condition) {
    case 'sun': return 'text-yellow-500';
    case 'partly': return 'text-blue-300';
    case 'cloud': return 'text-gray-500';
    case 'rain': return 'text-blue-600';
    case 'storm': return 'text-purple-600';
    default: return 'text-yellow-500';
  }
};